import { render } from "./Department.vue?vue&type=template&id=45fcbbb4&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=45fcbbb4&scoped=true&lang=css"
import "./Department.vue?vue&type=style&index=1&id=45fcbbb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fcbbb4"]])

export default __exports__